<template>
 <div class="carrusel-container-personajes">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-5">
        <h2 class="text-center carousel-title">Desinformación en acción</h2>
      </div>
      <div class="col-12">
        <VueSlickCarousel v-bind="settings" :arrows="true" :dots="true">
          <div :key="ix" v-for="(img, ix) in images" class="active carousel-item">
            <img
            :src="`/wp-content/interactivos/el-cartel-de-la-desinformacion-en-cusco${img.src}`"
            class="img-carrusel"
            blank="true"
            >
            <div class="cloud-message" :class="{'turn': img.turn == true}" v-html="img.title"></div>
          </div>
        </VueSlickCarousel>

      </div>
    </div>
  </div>
 </div>
</template>

<style>

  .carousel-title {
    font-size: 31px;
    color: #fff;
    font-family: "Fira Sans",sans-serif;
  }

  .carrusel-container-personajes {
    background-image: url('../assets/bg-sol.png');
    background-color: #000;
    background-repeat: repeat-y;
    background-size: cover;
    padding: 45px 0;
    width: 100%;
    overflow: hidden;
  }

  .carousel-item {
    padding: 0 0;
  }

  .slick-prev {
    left: 0;
    z-index: 99;
  }
  
  .slick-next {
    right: 0;
    z-index: 99;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 0.25;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
    color: #929292;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 1;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev:before, .slick-next:before {
    font-family: 'slick';
    font-size: 45px;
    line-height: 1;
    opacity: 0.75;
    color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .cloud-message {
    width: 100%;
    color: #fff;
    max-width: 400px;
    margin: 40px auto 0 auto;
    background-color: #316331;
    top: -50px;
    position: relative;
    padding: 10px;
    font-size: 16px;
    border-radius: 5px;
    transform: rotate(5deg);
    font-family: "Noto Sans";
    box-shadow: 0px 0px 4px 2px #91919161;

    &.turn {
      transform: rotate(-5deg);
    }
  }

  .img-carrusel {
    width: 100%;
    max-width: 420px;
    margin: 0 auto 0 auto;
    display: block;
    pointer-events: none;
  }

  .carousel-intro {
    font-weight: bold;
  }



</style>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  name: 'Carousel',
  components: {
    VueSlickCarousel
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  data() {
	return {
      settings: {
        "dots": true,
        "focusOnSelect": true,
        "infinite": false,
        "speed": 1000,
        "slidesToShow": 2,
        "slidesToScroll": 1,
        "touchThreshold": 6,
        "responsive": [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
      },
      images: [
        {
          src: '/fotos/c1_1.png',
          alt: 'Image 2',
          turn: false,
          title: '<strong class="carousel-intro">¿TORO MATA?</strong> Cuando el exalcalde de Espinar, Óscar Mollohuanca, fue hallado muerto, los medios reportaron que estaba desnudo e incluso atado de manos. Solo <i>El Diario del Cusco</i> dio como cierta —y en portada— una dudosa versión que afirmaba que a Mollohuanca le había  matado su propio toro. Mollohuanca estaba en el ojo de la justicia por las protestas de 2012 contra la minera Xtrata Tintaya.'
        },
        {
          src: '/fotos/c2_1.png',
          alt: 'Image 2',
          turn: true,
          title: '<strong class="carousel-intro">SOTO Y LOS FALSOS MUERTOS.</strong> En mayo de 2020, el hoy expresidente del Congreso, Alejandro Soto, difundió la desinformación de que se estaban enterrando masivamente en fosas comunes de la localidad de Huancaro a fallecidos por COVID-19. El medio <i>Cusco En Portada</i> explicó que se se trataba “de una inhumación masiva de 21 cadáveres no reclamados desde el año 2018 y que se encontraban acumulados en la morgue del Cusco. Todos ellos fallecieron por diversas razones, ninguno por Coronavirus”. (Fotos: X de <i>Latina</i>, Facebook de <i>Cusco En Portada</i>)'
        },
        {
          src: '/fotos/c3_1.png',
          alt: 'Image 2',
          turn: false,
          title: '<strong class="carousel-intro">GERMEN DE VIOLENCIA.</strong> El colectivo de los denominados Polos Blancos surgió de las Marchas por la Paz contra las protestas de 2022-203, pero hoy son señalados como el origen de ataques racistas, terruqueo y campañas de desprestigio desde los sectores conservadores, empresariales y políticos del Cusco. El caso emblemático ha sido el de Alejandra Urbina, quien se grabó a sí misma en una marcha de llamando “indios, ladrones y delincuentes” a los manifestantes.'
        },{
          src: '/fotos/respuesta_bayona.png',
          alt: 'Image 2',
          turn: false,
          title: '<strong class="carousel-intro">RESPUESTA Y ATAQUE.</strong> EL FOCO contactó a Ronald Calvo de <i>Qosqo Times</i>, a Karerina Bayona y a Fredy Fiascunari. Los tres se negaron a ser entrevistados: Fiascunari dijo que las preguntas de EL FOCO violaban su libertad de opinión, Bayona nos acusó de ser “un medio zurdo” y Calvo amenazó con hacer “un reportaje en Cusco de vuestro trabajo. Veremos qué encontramos en el camino”.'
        }
      ]
    }
  }
};
</script>
